import { Icon as LucideIcon } from 'lucide-react';
import { Icon } from '../Icon/Icon';
import { jsx as _jsx } from "react/jsx-runtime";
const iconNode = [['path', {
  d: 'm1.5 6 9.371 7.613a1.3 1.3 0 0 0 1.575 0L22.5 6',
  key: 'f5kbos'
}], ['rect', {
  x: '1.5',
  y: '3',
  width: '21',
  height: '18.375',
  rx: '2.625',
  key: 'sbk68w'
}]];
export const ProductMailbox = () => /*#__PURE__*/_jsx(Icon, {
  icon: LucideIcon,
  iconNode: iconNode,
  className: "lucide-custom-product-mailbox"
});